import React, { useEffect, useState } from "react";
import { FormControl, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import { FormikProps } from 'formik';
import Switch from '@mui/material/Switch';
import { useTranslation } from "react-i18next";

import { getSettings } from "../../api";

export interface AccountSettingsProps {
	formikProps: FormikProps<any>;
	onSettingsChanged?: (settings: UserSetting[]) => void;
}

export interface Setting {
	id: number;
	key: string;
	label: string;
	description: string;
	default_value: number;
	created_at: string;
	updated_at: string;
}

export interface UserSetting {
	user_id: number;
	setting_id: number;
	value: number;
	setting: Setting;
	created_at: string;
	updated_at: string;
}

const AccountSettings = (props: AccountSettingsProps) => {
	const { t } = useTranslation();

	const { values } = props.formikProps;

	const [userSettings, setUserSettings] = useState<UserSetting[]>([]);
	const [userSettingGroups, setUserSettingGroups] = useState<(UserSetting[])[]>([]);

	useEffect(() => {
		const fetchSettings = async () => {
			// Get all settings with their default values
			const response = await getSettings();

			if (response && response.status === 200) {
				const settings: UserSetting[] = response.data.data.map((s: Setting) => ({
					user_id: values.id, setting_id: s.id, value: s.default_value, setting: s
				}));

				for (const userSetting of (values.user_settings as UserSetting[])) {
					const i = settings.findIndex(s => s.setting_id === userSetting.setting.id);
					if (i >= 0 && settings[i]) settings[i]!.value = userSetting.value;
				}

				// Group user settings by their label

				const groups: (UserSetting[])[] = [];

				for (const s of settings) {
					if (!groups[s.setting.label as any]) groups[s.setting.label as any] = [];
					groups[s.setting.label as any]!.push(s);
				}

				setUserSettingGroups(groups);
				setUserSettings(settings);
			}
		}

		if (values.user_settings)
			fetchSettings();
	}, [values.id, values.user_settings]);

	const handleChange = (checked: boolean, us: UserSetting) => {
		const settings = [...userSettings];
		const i = settings.findIndex(s => s.setting_id === us.setting.id);

		if (i >= 0) {
			settings[i]!.value = checked ? 1 : 0;
			setUserSettings(settings);

			console.log(settings)
			if (props.onSettingsChanged) props.onSettingsChanged(settings);
		}
	};

	const settingRow = (us: UserSetting) => (
		<FormControlLabel
			key={us.setting.key}
			control={<Switch checked={us.value === 1}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event.target.checked, us)} />}
			label={t(us.setting.key)} />);

	return (
		<div className="account-settings">
			{userSettingGroups &&
				<FormControl component="fieldset" variant="standard">
					{Object.entries(userSettingGroups).map(([label, user_settings]) => (
						<>
							<FormLabel component="legend">{t(label)}</FormLabel>

							<FormGroup>
								{user_settings.map((value: UserSetting, _index: number, _array: UserSetting[]) => settingRow(value))}
							</FormGroup>
						</>
					))}
				</FormControl>}
		</div>
	);
}

export default AccountSettings;